import { McButton, McModal } from '@maersk-global/mds-react-wrapper';
import React from 'react';
import { useIntl } from 'react-intl';

export const DeleteHolidayModal = ({ closed, onConfirm }: { closed: () => void; onConfirm: () => void }) => {
  const { formatMessage } = useIntl();

  return (
    <McModal open closed={closed} dimension={'small'} heading="Entry Delete">
      <p>Are you sure you want to delete this entry?</p>
      <McButton
        slot="secondaryAction"
        appearance="neutral"
        variant="outlined"
        dialogaction="cancel"
        label={formatMessage({ id: 'cancel' })}
      />
      <McButton id="confirm" slot="primaryAction" appearance="error" click={onConfirm} label="Delete" />
    </McModal>
  );
};
